import React, { useEffect, useState } from "react";
import DoctorBanner from "../Layout/DoctorBanner";
import DoctorSearchBar from "../Layout/DoctorSearchBar";
import Greeting from "../Layout/Greeting";
import { get } from "../../utility/fetch";
import { Button } from "@mui/material";

const DoctorsEngagement = () => {

    const [data, setData] = useState([])
    const getEngagedDoctors = async () => {
        try {
            const response = await get(`/Doctors/EngagedDoctors/${sessionStorage.getItem("userId")}`);
            console.log('Response:', response);
            setData(response);
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
    }

    useEffect(() => {
        getEngagedDoctors();
    }, []);


    return (
        <div className="doctors-engagement w-100 p-20">

            <Greeting name={sessionStorage.getItem("name")} />
            <DoctorSearchBar data={data} setData={setData} />

            {
                data?.map((item) => (
                    <DoctorBanner data={item} />
                ))
            }

          
        </div>
    );
}

export default DoctorsEngagement;